import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { SharedService } from '@services/shared.service';
import { ApiCustomerService } from '@services/api-customer.service';
import { ApiAccountService } from '@services/api-account.service';

import { PageBase } from '@shared/page-base.component';

import { RegisterAccountModel, RegisterAddressModel } from '@models/RegisterModel';
import { CustomerModel, CustomerWithoutRegisterModel } from '@models/CustomerModel';
import { UntypedFormGroup } from '@angular/forms';
import { GeoDataStructure } from '@shared/geo-data';


@Component({
    selector: 'app-register-account',
    templateUrl: './register-account.component.html',
    styleUrls: ['./register.component.scss']
})

export class RegisterAccountComponent extends PageBase implements OnInit {

    @Input() isReceiveRegister: boolean = false;
    @Output() registerStep = new EventEmitter<number>();
    //se setea la info del customer si se accede desde el checkout
    @Input() customerWithoutRegister: CustomerWithoutRegisterModel;


    user: CustomerModel;

    loaded = false

    constructor(public location: Location,
        public router: Router,
        public sharedService: SharedService,
        private apiAccountService: ApiAccountService,
        private apiCustomerService: ApiCustomerService) {
        super(location, router, sharedService);
    }

    ngOnInit(): void {

        this._getAccount();
    }

    onSave(registerForm: UntypedFormGroup): void {


        const session = this.apiCustomerService.getSession();

        if (registerForm && session) {

            let geoDataStructure = GeoDataStructure.country(this.user.country);

            const registerModel = new RegisterAccountModel();

            registerModel.firstName = registerForm.controls.firstName.value;
            registerModel.lastName = registerForm.controls.lastName.value;
            registerModel.genderType = registerForm.controls.genderType.value;
            registerModel.idCardType = registerForm.controls.idCardType.value;
            registerModel.idCard = registerForm.controls.idCard.value;
            registerModel.phone = registerForm.controls.phone.value;
            registerModel.birthDate = new Date(new Date(Number(registerForm.controls.birthYear.value), Number(registerForm.controls.birthMonth.value) - 1, Number(registerForm.controls.birthDay.value)));

            //address
            const registerAddressModel = new RegisterAddressModel();

            // SEND THE ADDRESS
            geoDataStructure.forEach(level => {
                const controlValue = registerForm.get(level.key)?.value;
            
                if (level.ordinal === 1) registerAddressModel.province = controlValue; 
                else if (level.ordinal === 2)registerAddressModel.canton = controlValue;
                else if (level.ordinal === 3) registerAddressModel.distric = controlValue;
            });

            if (registerModel) {

                registerModel.id = session.user.id;

                this.sharedService.setLoading(true);

                this.apiAccountService.registerAccount(registerModel).then(
                    (success) => {

                        this.sharedService.setLoading(false);

                        this.apiCustomerService.loadAccount().then(
                            () => {

                                this.onSaveAddress(registerAddressModel);
                            },
                            (err: any) => {

                                // display error
                                const errMsg = this.apiCustomerService.getErrorMsg(err, 'El datos inválidos.');
                                this.sharedService.showErrorAlert(null, errMsg).then(_ => this.apiCustomerService.logout(this.router));
                            }
                        );
                    },
                    (error) => {

                        this.sharedService.setLoading(false);
                        
                        // display error
                        const errMsg = this.apiCustomerService.getErrorMsg(error, 'Ocurrió un error al registrar la cuenta.');
                        this.sharedService.showErrorAlert(null, errMsg);
                    }
                );
            }
        }
    }

    //address
    onSaveAddress(registerModel: RegisterAddressModel): void {

        const session = this.apiCustomerService.getSession();
        if (session && registerModel) {

            registerModel.id = session.user.id;

            this.sharedService.setLoading(true);

            this.apiAccountService.registerAddress(registerModel).then(
                (success) => {

                    this.apiCustomerService.loadAccount().then(
                        () => {

                            this.sharedService.setLoading(false);

                            if (!this.isReceiveRegister) {

                                // TODO: Revisar el modal de givi de bienvenida, no navega al market despues de aceptarlo
                                // success register
                                // this.router.navigate(['/bienvenido'], { queryParams: { signup: 'success' } });

                                // navigate to dashboard when logged in
                                this.router.navigate(['/market'], { queryParams: { loadAccount: 1, login: 'success' } });
                            } else {

                                // success register into receive
                                this.registerStep.emit(4);
                                return
                            }

                        },
                        (err: any) => {

                            this.sharedService.setLoading(false);

                            // display error
                            const errMsg = this.apiCustomerService.getErrorMsg(err, 'El nombre de usuario o contraseña es inválido.');
                            this.sharedService.showErrorAlert(null, errMsg).then(() => this.apiCustomerService.logout(this.router));
                        }
                    );
                },
                (error: any) => {

                    this.sharedService.setLoading(false);
                    // display error
                    const errMsg = this.apiCustomerService.getErrorMsg(error, 'Ocurrió un error al registrar la cuenta.');
                    this.sharedService.showErrorAlert(null, errMsg);
                }
            );
        }
    }

    private _getAccount(): void {

        this.sharedService.setLoading(true);

        this.apiAccountService.getAccount().then(
            (user: CustomerModel) => {

                this.loaded = true
                this.user = user;

                if (this.customerWithoutRegister) {

                    this.user.name = this.customerWithoutRegister?.name;
                    this.user.lastName = this.customerWithoutRegister?.lastName;
                }

                this.sharedService.setPageBack(false);
                // this.sharedService.setPageTitle(this.user.email);

                this.sharedService.setLoading(false);
            }
        ).catch(
            () => {

                this.loaded = true
                this.sharedService.setLoading(false);
            }
        );
    }
}
